var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBelize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 20C40 13.1358 36.5415 7.08013 31.2724 3.47825L20 2.60864L8.72758 3.47817C3.45859 7.08013 0 13.1359 0 20C0 26.8643 3.45859 32.9198 8.72758 36.5217L20 37.3913L31.2724 36.5218C36.5415 32.9198 40 26.8643 40 20Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2725 3.47822C28.0627 1.284 24.1816 -6.10352e-05 20.0001 -6.10352e-05C15.8186 -6.10352e-05 11.9374 1.284 8.72766 3.47822H31.2725Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.72766 36.5217C11.9373 38.7159 15.8186 40 20.0001 40C24.1816 40 28.0627 38.7159 31.2725 36.5217H8.72766Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 29.5652C25.2828 29.5652 29.5653 25.2827 29.5653 20C29.5653 14.7173 25.2828 10.4348 20 10.4348C14.7173 10.4348 10.4348 14.7173 10.4348 20C10.4348 25.2827 14.7173 29.5652 20 29.5652Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 27.8261C24.3222 27.8261 27.826 24.3222 27.826 20C27.826 15.6778 24.3222 12.1739 19.9999 12.1739C15.6777 12.1739 12.1738 15.6778 12.1738 20C12.1738 24.3222 15.6777 27.8261 19.9999 27.8261Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 25.2174C22.8815 25.2174 25.2174 22.8815 25.2174 20C25.2174 17.1185 22.8815 14.7825 20 14.7825C17.1185 14.7825 14.7826 17.1185 14.7826 20C14.7826 22.8815 17.1185 25.2174 20 25.2174Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 18.6956L17.174 19.9999V22.1738L20 23.913L22.8261 22.1738V19.9999L20 18.6956Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.174 17.3913H22.8261V20H17.174V17.3913Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_180"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBelize);
export default __webpack_public_path__ + "static/media/belize.6101b9d8d8caab15fd07ab9e0253e2a0.svg";
export { ForwardRef as ReactComponent };